export default "__VITE_ASSET__DLdqg$Fq__"